export enum IdmlReadOption {
    SpreadsOnly = 0,
    SpreadsAndMasterSpreads = 1,
}
